import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";
import checkIcon from "../../../resources/images/check-white.svg";

const styles = createUseStyles((theme) => ({
  chooseTierModal: {
    width: "480px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex",
        },
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px",
      },
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
      marginBottom: "8px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
    },
    "& .modal-body": {
      padding: "0px 24px 24px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    },
  },
  chooseTierModalWrapper: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContent: {
    margin: "20px 0 0 0",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    maxHeight: "285px",
    width: "100%",
    padding: "2px",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  radioContainerActive: {
    cursor: "pointer",
    display: "flex",
    backgroundColor: colors.primary50Blue,
    outline: "2px solid " + colors.primary600Blue,
    borderRadius: "12px",
    padding: "15px",
    "& input": {
      appearance: "none",
    },
  },
  radioContainer: {
    extend: "radioContainerActive",
    backgroundColor: "inherit",
    outline: "1px solid " + colors.lightGrey,
    "&:hover": {
      outline: theme.modal.optionHover.border,
      "& [class*='checkmark']":{
        backgroundColor: theme.modal.optionHover.backgroundColor,
        border: theme.buttons.primary.border,
      },
    },
  },
  radioContainerDisabled: {
    extend: "radioContainerActive",
    cursor: "default",
    backgroundColor: colors.brightBlue,
    outline: "1px solid " + colors.lightGrey,
    "& p": {
      color: colors.paleGrey + "!important",
    },
  },
  radioTextActive: {
    display: "flex",
    justifyContent: "center",
    gap: "4px",
    "& h6": {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: colors.darkBlue,
      margin: "0px",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.darkBlue,
      margin: "0px",
    },
  },
  radioText: {
    extend: "radioTextActive",
    "& h6": {
      color: colors.grey,
    },
    "& p": {
      color: colors.mediumGrey,
    },
  },
  checkmark: {
    flexShrink: 0,
    marginLeft: "auto",
    height: "16px",
    width: "16px",
    border: "1px solid " + colors.darkGrey,
    borderRadius: "50%",
    margin: "auto 0px",
  },
  checkmarkChecked: {
    backgroundImage: `url(${checkIcon})`,
    backgroundColor: `${colors.primary600Blue} !important`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    border: "none",
    backgroundSize: "10px",
  },
  btnContainer: {
    marginTop: "32px",
  },
  btnsRow: {
    flexWrap: "nowrap",
  },
  cancelBtn: {
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
    height: "100%",
    alignItems: "center",
  },
  chooseBtn: {
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
  },
  colCancel: {
    padding: "0px",
    marginRight: "12px",
  },
  colChoose: {
    padding: "0px",
  },
}));

export default styles;
